import React from 'react';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <h1 className="logo">AppsDNA</h1>
      </div>
    </nav>
  );
}

export default Navbar;